import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M1.667 10.733V9.267c0-.867.708-1.584 1.583-1.584 1.508 0 2.125-1.066 1.367-2.375A1.583 1.583 0 0 1 5.2 3.15l1.442-.825c.658-.392 1.508-.158 1.9.5l.091.158c.75 1.309 1.984 1.309 2.742 0l.092-.158c.391-.658 1.241-.892 1.9-.5l1.441.825a1.58 1.58 0 0 1 .584 2.158c-.759 1.309-.142 2.375 1.366 2.375.867 0 1.584.709 1.584 1.584v1.466c0 .867-.709 1.584-1.584 1.584-1.508 0-2.125 1.066-1.366 2.375a1.58 1.58 0 0 1-.584 2.158l-1.441.825c-.659.392-1.509.158-1.9-.5l-.092-.158c-.75-1.309-1.983-1.309-2.742 0l-.091.158c-.392.658-1.242.892-1.9.5L5.2 16.85a1.58 1.58 0 0 1-.583-2.158c.758-1.309.141-2.375-1.367-2.375a1.59 1.59 0 0 1-1.583-1.584"
    }, null, -1)
  ]))]))
}
export default { render: render }